import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import * as _ from 'lodash';
import { AppService } from 'src/@core/services/app.service';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[showIfEntity]'
})
export class ShowIfEntityDirective implements OnInit {

  // tslint:disable-next-line:variable-name
  private _entity: string[];
  constructor(private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private appService: AppService
  ) { }

  @Input() set showIfEntity(entity: string[]) {
    this._entity = entity;
  }

  ngOnInit(): void {
    this.appService.currentUser.subscribe((currentUser: any) => {
      if (!currentUser) { return; }
      if (currentUser) {
        if (currentUser && currentUser.entity && currentUser.entity.entityType) {
          const currentEntityType = currentUser.entity.entityType;
          const requiredEntityTypes = this._entity; // This is now an array

          if (requiredEntityTypes.includes(currentEntityType)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
          } else {
            this.viewContainer.clear();
          }
        } else {
          this.viewContainer.clear();
        }
      }
    });
  }
}
